import {
  Component,
  DestroyRef,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { IconRegistry } from '@prlw/libs/icons/icon-registry';
import { Subject, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'prlw-icon',
  template: '',
  standalone: false,
})
export class IconComponent implements OnChanges {
  @Input() public name: string = '';

  private readonly name$ = new Subject<string>();

  constructor(
    private readonly elementRef: ElementRef,
    private readonly iconRegistry: IconRegistry,
    private readonly destroyRef: DestroyRef,
  ) {
    this.name$
      .pipe(
        switchMap((name) => this.iconRegistry.getIcon(name)),
        takeUntilDestroyed(destroyRef),
      )
      .subscribe((icon) => {
        const classList = (this.elementRef.nativeElement as Element).classList;
        this.elementRef.nativeElement.innerHTML = icon.svg;
        if (classList.contains('prlw-icon')) return;
        classList.add('prlw-icon');
      });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['name']) {
      if (changes['name'].currentValue) {
        if (typeof changes['name'].currentValue === 'string') {
          this.name$.next(changes['name'].currentValue);
        }
      }
    }
  }
}
